<template>
	<div v-if="errorLogs.length>0">
		<el-badge :is-dot="true" style="line-height: 25px;margin-top: -5px;" @click.native="dialogTableVisible=true">
			<el-button style="padding:8px 10px;" size="small" type="danger">
				<svg-icon icon-class="bug" />
			</el-button>
		</el-badge>
		<el-dialog :visible.sync="dialogTableVisible" width="80%" append-to-body>
			<div slot="title">
				<span style="padding-right: 10px;">Error Log</span>
				<el-button size="mini" type="primary" icon="el-icon-delete" @click="clearAll">清除所有</el-button>
			</div>
			<el-table :data="errorLogs" border>
				<el-table-column label="信息">
					<template slot>
						
					</template>
				</el-table-column>
				<el-table-column label="源"></el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name:'ErrorLog',
	data(){
		return {
			dialogTableVisible:false
		}
	},
	computed:{
		errorLogs(){
			return this.$store.getters.errorLogs
		}
	},
	methods:{
		clearAll(){
			this.dialogTableVisible=false
			this.$store.dispatch('errorLog/clearErrorLog')
		}
	}
}
</script>

<style>
</style>
